import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

export default function LabsDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    

    const initialValues = {
        LabName: '',
        IsActive: false
    };

    const validFormSchema = Yup.object({
        LabName: Yup
            .string('Enter a Lab Name')
            .required('Lab Name is Required'),
        IsActive: Yup
            .boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            Name: values.LabName,
            IsActive: values.IsActive
        };

        handleDialogCallback(msg);
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {

    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Lab
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Lab
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Lab Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="LabName"
                                            variant="outlined"
                                            id="outlined-labName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.LabName}
                                            error={props.touched.LabName && Boolean(props.errors.LabName)}
                                            helperText={props.touched.LabName && props.errors.LabName}                                          
                                            label="Lab Name"
                                        />
                                    </FormControl>
                                </div>
                                <FormControl sx={{ m: 1 }}>
                                    <FormControlLabel
                                        name="IsActive"
                                        label="Active"
                                        control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                    />
                                </FormControl>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>                
            </Dialog>
        </div>
    );
}